module.exports = __webpack_public_path__ + "static/media/email_icon.ae03a60d.svg";